module.exports = __webpack_public_path__ + "static/media/Decisions_Step7_endcard.5410d368.jpg";